export const totalEngagementsEmptyState = {
  totalEnqueuedEngageUsers: 0,
  totalSentMessages: 0,
  totalLostEngageUsers: 0,
};
